import { RegExPattern, WidgetConfiguration } from './types';

export function parseRegExPatternsDefaults(
    id: string,
    defaultValue: string = '',
    regExPatterns: RegExPattern[]
): WidgetConfiguration {
    const regExPatternConfigurations: WidgetConfiguration = {};
    const config: WidgetConfiguration = {};
    const partsConfig: WidgetConfiguration = {};
    const value = 'value';
    const parts = 'parts';

    regExPatterns.forEach(
        (regExPattern): void => {
            const { pattern, matchIndex = 0, configKey } = regExPattern;
            const re = new RegExp(pattern);
            const matchResult = defaultValue.match(re);
            partsConfig[configKey] = matchResult ? matchResult[matchIndex] : null;
        }
    );

    config[value] = defaultValue;
    config[parts] = partsConfig;
    regExPatternConfigurations[id] = config;

    return regExPatternConfigurations;
}
